<template>
  <vue-draggable-resizable
    class="draggableItem"
    drag-cancel=".dragCancel"
    >
    <div class="draggableItem__header">
      <span class="draggableItem__title">Widget template</span>
      <a
        href="#"
        class="draggableItem__close dragCancel"
        @click.prevent="close(widget['.key'])"
        v-b-tooltip.hover
        title="close"
        >
        <icon name="remove" />
      </a>
    </div>
    <div class="draggableItem__body">
      <b-form
        class="widgetEdit__form"
        @submit.prevent="save"
        >
        <div class="widgetEdit__content">
          <div>
            <b-form-group label="Widget title:">
              <b-form-input
                v-model="title"
                type="text"
                @keydown.ctrl.83.native.prevent="save"
                class="dragCancel"
                />
            </b-form-group>
          </div>
          <div>
            <b-form-group label="Widget classes:">
              <b-form-input
                v-model="classes"
                type="text"
                @keydown.ctrl.83.native.prevent="save"
                class="dragCancel"
                />
            </b-form-group>
          </div>
          <div class="widgetEdit__editor">
            <codemirror
              :value="code"
              :options="cmOptions"
              @keydown.ctrl.83.native.prevent="save"
              @input="onCmCodeChange"
              class="dragCancel"
              :ref="'draggable_' + widget['.key']"
              />
          </div>
          <div>
            <b-button
              variant="primary"
              size="sm"
              type="submit"
              :disabled="!changed"
              class="dragCancel"
              >
              Save
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </vue-draggable-resizable>
</template>

<script>
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

let $ = window.$

export default {
  props: ['widget'],
  data: function () {
    return {
      title: this.widget.title,
      code: this.widget.template,
      classes: this.widget.classes,
      cmOptions: {
        tabSize: 2,
        mode: 'text/x-vue',
        lineNumbers: true,
        line: true
      },
      width: 0,
      height: 0,
      x: 0,
      y: 0
    }
  },
  computed: {
    grid () {
      let grid = []
      for (let idx of this.widgets) {
        grid.push(idx)
      }
      return grid
    },
    changed () {
      if (this.code != this.widget.template) return true // eslint-disable-line
      if (this.title != this.widget.title) return true // eslint-disable-line
      return false
    }
  },
  methods: {
    onResize: function (x, y, width, height) {
      this.x = x
      this.y = y
      this.width = width
      this.height = height
    },
    onDrag: function (x, y) {
      this.x = x
      this.y = y
    },
    close (key) {
      this.$store.commit('editWidget', {
        key,
        insert: false
      })
    },
    onCmCodeChange (code) {
      this.code = code
    },
    save () {
      let widget = window.$.extend({}, this.widget)
      let key = widget['.key']
      delete widget['.key']
      widget.title = this.title || ''
      widget.template = this.code || ''
      widget.classes = this.classes || ''

      this.$store.commit('addProcess', {
        process: 'updateWidget',
        message: 'Updating'
      })

      db.widgets.update(key, widget, (err) => {
        this.$store.commit('deleteProcess', 'updateWidget')
        if (err) this.$store.commit('addError', err.message)

        eventBus.$emit('widgetTemplateUpdated', this.$store.state.currentTab)
      })
    }
  },
  mounted () {
    $(this.$refs['draggable_' + this.widget['.key']].$el)
      .find('textarea')
      .focus()
  }
}
</script>

<style lang="scss" scoped>
@import '~$scss/globals';

.widgetEdit {
  .draggableItem {
    min-height: 400px;
  }
  &__form {
    height: 100%;
  }
  &__content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  &__editor {
    flex: 1;
    height: calc(100% - 120px);
    padding-bottom: 15px;
    overflow: auto;
  }
}
.vue-codemirror {
  height: 100%;
  border: 1px solid $borderColor1;
}
.CodeMirror {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/WidgetsEdit/Draggable.vue